import { Link } from 'react-router';
import { cn } from '@dinewise/utils';
import { $path } from 'safe-routes';
import { eventStatusStyles, formatEventStatusLabel } from './event-status-styles.ts';
import type { HomeEvent } from './home.types.ts';

type EventRowProps = {
  event: HomeEvent;
};

export const EventRow = ({ event }: EventRowProps) => {
  const statusLabel = formatEventStatusLabel(event.status);
  const statusClassName = eventStatusStyles[event.status];

  return (
    <Link
      to={$path('/reservations/:id', { id: event.id })}
      className="flex w-full items-start gap-3 rounded-2xl py-2 text-left"
    >
      <div className="flex w-[52px] shrink-0 flex-col items-center rounded-xl bg-ande-black py-2">
        <span className="font-bold text-[10px] text-white uppercase tracking-[0.5px]">
          {event.dateLabel}
        </span>
        <span className="-mt-0.5 font-bold text-lg text-white leading-7">{event.dayOfMonth}</span>
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <p className="min-w-0 flex-1 truncate font-sans font-medium text-ande-black text-base leading-6">
            {event.title}
          </p>
          <span
            className={cn(
              'shrink-0 rounded-full px-2 py-0.5 font-semibold text-[10px]',
              statusClassName,
            )}
          >
            {statusLabel}
          </span>
        </div>
        <div className="font-sans text-ande-gray-300 text-xs leading-5">
          <div className="flex items-center gap-2 truncate">
            <span className="font-medium">{event.hostName}</span> ·{' '}
            <span className="font-medium">{event.timeLabel}</span> ·{' '}
            <span className="font-medium">{event.guestCount} guests</span> ·{' '}
            <span className="font-medium">
              {event.tripleseatId ? `TS #${event.tripleseatId}` : ''}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};
